// Report addresses: /reports/<slug>?f=<filters>[&popout=1]. `f` is the
// report's filters (Filters/filterState.js) as JSON in base64url, so the
// address works on its own - reloaded, shared, or in a new window.
import ROUTES from "../../../AppRouter/routes";

const toBase64Url = (text) =>
  btoa(
    Array.from(new TextEncoder().encode(text), (b) => String.fromCharCode(b)).join("")
  )
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

const fromBase64Url = (value) => {
  const b64 = value.replace(/-/g, "+").replace(/_/g, "/");
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

export const encodeFilters = (filters) => toBase64Url(JSON.stringify(filters ?? {}));

/** The filters in `f`, or null when it is missing or unreadable. */
export const decodeFilters = (value) => {
  if (!value) return null;
  try {
    const parsed = JSON.parse(fromBase64Url(value));
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const reportPath = (slug, { filters, popout } = {}) => {
  const params = new URLSearchParams();
  if (popout) params.set("popout", "1");
  if (filters) params.set("f", encodeFilters(filters));
  const query = params.toString();
  return `${ROUTES.reports}/${slug}${query ? `?${query}` : ""}`;
};

export const isPopout = (search) => new URLSearchParams(search).get("popout") === "1";
